import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
	Alpine.data('faqGroup', () => ({
		selectedGroup: null,
		init() {
			const firstGroup = document.querySelector('.faq-group');
			if (firstGroup) {
				this.selectedGroup = firstGroup.getAttribute('data-group-name');
			}

			this.handleUrlHash();
		},
		handleUrlHash() {
			const hash = window.location.hash;
			if (hash && hash.length > 1) {
				try {
					const targetId = decodeURIComponent(hash.substring(1));
					const [groupName, indexParam] = targetId.split('-');
					const targetIndex = indexParam
						? parseInt(indexParam, 10) - 1
						: null;

					const faqGroup = document.querySelector(
						`[data-group-name="${groupName}"]`
					);
					if (faqGroup) {
						if (targetIndex !== null) {
							this.selectedGroup = groupName;

							setTimeout(() => {
								console.log('Opening FAQ item', targetIndex);
								openFaqItemByIndex(faqGroup, targetIndex);
							}, 100);
						} else {
							this.selectGroup(groupName);
						}
					}
				} catch (error) {
					console.warn('Error decoding URL hash:', error);
					// Fallback to original behavior if decoding fails
					const targetId = hash.substring(1);
					const [groupName, indexParam] = targetId.split('-');
					const targetIndex = indexParam
						? parseInt(indexParam, 10) - 1
						: null;

					const faqGroup = document.querySelector(
						`[data-group-name="${groupName}"]`
					);
					if (faqGroup) {
						if (targetIndex !== null) {
							this.selectedGroup = groupName;

							setTimeout(() => {
								openFaqItemByIndex(faqGroup, targetIndex);
							}, 100);
						} else {
							this.selectGroup(groupName);
						}
					}
				}
			}
		},
		selectGroup(groupName) {
			this.selectedGroup = groupName;

			setTimeout(() => {
				this.expandFirstItem(groupName);
			}, 50);
		},
		expandFirstItem(groupName) {
			const faqGroup = document.querySelector(
				`[data-group-name="${groupName}"]`
			);
			if (faqGroup) {
				const faqItems = faqGroup.querySelectorAll('[x-data*="open:"]');
				if (faqItems.length > 0) {
					faqItems.forEach((item) => {
						const alpineData = Alpine.$data(item);
						if (alpineData) {
							alpineData.open = false;
						}
					});

					const firstItem = faqItems[0];
					const alpineData = Alpine.$data(firstItem);
					if (alpineData) {
						alpineData.open = true;
					}
				}
			}
		},
	}));
});

const handleLinks = () => {
	const faqLinks = document.querySelectorAll('.faq-item a');
	const faqsContainer = document.querySelector('.faqs-container');

	if (!faqLinks.length || !faqsContainer) return;

	faqLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const href = link.getAttribute('href');
			const targetId = href.substring(1);

			if (targetId) {
				const [groupName, indexParam] = targetId.split('-');
				const targetIndex = indexParam
					? parseInt(indexParam, 10) - 1
					: null;

				const faqGroup = document.querySelector(
					`[data-group-name="${groupName}"]`
				);
				if (faqGroup) {
					const alpineData = Alpine.$data(faqsContainer);

					if (alpineData) {
						if (targetIndex !== null) {
							alpineData.selectedGroup = groupName;

							setTimeout(() => {
								openFaqItemByIndex(faqGroup, targetIndex);
							}, 100);
						} else {
							alpineData.selectGroup(groupName);
						}
					}
				}
			}
		});
	});
};

const openFaqItemByIndex = (faqGroup, index) => {
	const faqItems = faqGroup.querySelectorAll('[x-data*="open:"]');

	if (faqItems[index]) {
		faqItems.forEach((item) => {
			const alpineData = Alpine.$data(item);
			if (alpineData) {
				alpineData.open = false;
			}
		});

		const targetItem = faqItems[index];
		const alpineData = Alpine.$data(targetItem);
		if (alpineData) {
			alpineData.open = true;

			setTimeout(() => {
				targetItem.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}, 150);
		}
	}
};

document.addEventListener('DOMContentLoaded', () => {
	handleLinks();
});
